<script>
import { number } from "@coders-tm/vue-number-format";
import { required } from "vuelidate/lib/validators";
import { extend } from "vee-validate";
import Swal from "sweetalert2";
import CompanyAPI from "@/services/company/companyAPI";
import CopasstActAPI from "@/services/standards/copasst/copasstActAPI";
import CandidatesCopasstAPI from "@/services/standards/copasst/candidates/candidatesAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import ItemAPI from "@/services/items/itemsAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import DocumentActions from "@/components/document/DocumentActions.vue";

/**
 * This validation verifies that the number of assistants entered is in the correct range.
 */
extend("positive", {
  validate(value, { args }) {
    if (value >= 10 && value <= 50) {
      if (value >= 10 && value <= args) {
        return true;
      } else false;
    } else false;
  },
  params: ["args"],
  message: (fieldName, placeholders) => {
    return `El ${fieldName} debe ser mayor o igual a 10 y menor o igual a la cantidad de empleados en la empresa`;
  },
});

export default {
  components: {
    number,
    DocumentActions,
  },
  props: {
    // companyID: {
    //   type: Number,
    //   default: 0,
    // },
    copasstID: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      submitted: false,
      exist: false,
      showNotification: false,
      message: "",
      item: null,
      itemData: null,
      number: {
        separator: ".",
        precision: 0,
        masked: false,
        min: 0,
        max: 50,
        minimumFractionDigits: 0,
        nullValue: 0,
      },
      copasstAct: {
        announcement_date: null,
        copasst_place: null,
        copasst_begin_hour: null,
        copasst_ending_hour: null,
        number_assistants: 0,
        certificate: null,
        companies_id: null,
      },
      postulatesNumber: 10,
      postulates: [],
      company: this.$store.getters["company/getCompany"].nit || null,
      candidates: [],
      employees: [],
      positions: [
        {
          id: 1,
          name: "REPRESENTANTE EMPLEADOS",
        },
        {
          id: 2,
          name: "SUPLENTE REPRESENTANTE EMPLEADOS",
        },
      ],
      positionsEmployer: [
        {
          id: 3,
          name: "DESIGNADO EMPLEADOR PRINCIPAL",
        },
        {
          id: 4,
          name: "DESIGNADO EMPLEADOR SUPLENTE",
        },
      ],
      employer: [],
      candidatesSelect: [],
      employerCandidates: [],
      certificateExist: false,
      workflowStatus: "draft",
      signedAt: null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      user: this.$store.state.auth || null,
      file: null,
      copastID: 1,
      guardando: false,
      loading1: true,
    };
  },
  computed: {
    isConfSigned() {
      return this.workflowStatus === "signed";
    },
    conformacionApi() {
      return {
        pdfUrl: (id) => CopasstActAPI.pdfUrl(id),
        sign: (id, payload) => CopasstActAPI.sign(id, payload),
      };
    },
  },
  validations: {
    copasstAct: {
      announcement_date: {
        required,
      },
      copasst_place: {
        required,
      },
      copasst_begin_hour: {
        required,
      },
      copasst_ending_hour: {
        required,
      },
    },
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(6)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 6)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method allows change the status of the showNotification variable.
     */
    setShowNotification() {
      this.showNotification = !this.showNotification;
    },

    /**
     * Get file name with format.
     * @param {String} file Is the name the file.
     * @return {String} The new format the file name.
     */
    getFile(file) {
      if (this.exist) {
        try {
          const name = file.split("/");
          return name[name.length - 1];
        } catch (error) {
          return null;
        }
      }
    },

    /**
     * This method is called when the user clicks on the button to upload the ARL certificate.
     */
    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    /**
     * This method is used to upload the ARL certificate to Digital Ocean.
     */
    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.copasstAct.certificate)
        } else {
          name = this.file.name
        }
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.company}/1.1.6/copass/${this.copastID}/${name}`;
        } else {
          url = `sst-prod/${this.company}/1.1.6/copass/${this.copastID}/${name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.copasstAct.certificate = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * This method is used to print the copasst act.
     * Is necessary that postulates are loaded.
     */
    print() {
      if (
        (this.postulates.length > 0 || this.employer.length > 0) &&
        this.exist
      ) {
        let postulates = [];

        this.postulates.forEach((postulate) => {
          if (postulate.employee_id) {
            postulates.push(postulate);
          }
        });

        let employer = [];

        this.employer.forEach((emp) => {
          if (emp.employee_id) {
            employer.push(emp);
          }
        });

        if (postulates.length < 4) {
          Swal.fire({
            title: "¡Alerta!",
            text: "¡Debe seleccionar al menos cuatro empleados como postulados!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        if (employer.length < 2) {
          Swal.fire({
            title: "¡Alerta!",
            text: "¡Debe seleccionar al menos dos empleados como designados empleador!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        function objectsRepeated(array) {
          for (var i = 1; i < array.length; i++) {
            for (var j = 0; j < i; j++) {
              if (array[i].employee_id === array[j].employee_id) {
                return true;
              }
            }
          }
          return false;
        }

        function statusRepeated(array) {
          for (var i = 1; i < array.length; i++) {
            for (var j = 0; j < i; j++) {
              if (
                array[i].copasst_status === array[j].copasst_status &&
                (array[i].copasst_status === 3 || array[i].copasst_status === 4)
              ) {
                return true;
              }
            }
          }
          return false;
        }

        if (objectsRepeated(postulates)) {
          Swal.fire({
            title: "¡Alerta!",
            text: "¡No puede haber empleados repetidos en la lista de postulantes!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        if (objectsRepeated(employer)) {
          Swal.fire({
            title: "¡Alerta!",
            title: "¡No puede haber empleados repetidos en la lista de designados!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        if (this.employer === this.postulates) {
          Swal.fire({
            title: "¡Alerta!",
            text: "¡No puede haber empleados repertidos!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        if (statusRepeated(employer)) {
          Swal.fire({
            title: "¡Alerta!",
            text: "¡No puede haber empleados con cargos repetidos en la lista de designados!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        this.print();
      } else {
        Swal.fire({
          title: "¡Alerta!",
          text: "¡Debe indicar la cantidad de postulantes!",
          type: "warning",
          icon: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        return;
      }
    },

    // Descarga el acta de conformación BRANDED (logo + control + firma del encargado).
    print() {
      if (!this.copasstID) {
        Swal.fire("Alerta", "Guarda el acta antes de descargarla.", "warning");
        return;
      }
      window.open(CopasstActAPI.pdfUrl(this.copasstID), "_blank");
    },

    onConfSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },

    getConformacionStatus() {
      if (!this.copasstID) return;
      CopasstActAPI.getConformacionStatus(this.copasstID)
        .then((res) => {
          if (!res) return;
          this.workflowStatus = res.workflow_status || "draft";
          this.signedAt = res.signed_at || null;
        })
        .catch((e) => console.log("conformacion-status error", e));
    },

    /**
     * This method is used to save the all data of the copasst act.
     * This includes the header copasst act, the postulates and the employers involved.
     */
    async save() {
      try {
        this.guardando = true;
        this.loading1 = true;
        this.copasstAct.companies_id = this.companyID;
        this.submitted = true;

        // Validación del formulario
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.submitted = false;
          return;
        }

        // Función para verificar duplicados en una lista
        function hasDuplicates(array) {
          const seen = new Set();
          for (const item of array) {
            if (seen.has(item.employee_id)) {
              return true; // Hay duplicados
            }
            seen.add(item.employee_id);
          }
          return false; // No hay duplicados
        }

        // Filtrar postulados y designados para eliminar objetos con employee_id nulo
        const validPostulates = this.postulates.filter((postulate) => postulate.employee_id !== null);
        const validEmployer = this.employer.filter((emp) => emp.employee_id !== null);

        // Verificar duplicados en postulados válidos
        if (hasDuplicates(validPostulates)) {
          this.loading1 = false;
          Swal.fire({
            title: "¡Alerta!",
            text: "¡No puede haber empleados repetidos en la lista de postulados!",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        // Verificar duplicados en designados válidos
        if (hasDuplicates(validEmployer)) {
          this.loading1 = false;
          Swal.fire({
            title: "¡Alerta!",
            text: "¡No puede haber empleados repetidos en la lista de designados!",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        // Resto de la lógica de validación y guardado
        let postulates = validPostulates;
        let employer = validEmployer;

        let president = [];
        let secretary = [];

        this.postulates.forEach((postulate) => {
          if (postulate.president) president.push(postulate);
          if (postulate.secretary) secretary.push(postulate);
        });

        this.employer.forEach((emp) => {
          if (emp.president) president.push(emp);
          if (emp.secretary) secretary.push(emp);
        });

        if (president.length !== 1) {
          this.loading1 = false;
          Swal.fire({
            title: "¡Alerta!",
            text: "¡Debe seleccionar al menos a un presidente!",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        if (secretary.length !== 1) {
          this.loading1 = false;
          Swal.fire({
            title: "¡Alerta!",
            text: "¡Debe seleccionar al menos a un secretario!",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        if (postulates.length < 4) {
          this.loading1 = false;
          Swal.fire({
            title: "¡Alerta!",
            text: "¡Debe seleccionar al menos cuatro postulados!",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        if (employer.length < 2) {
          this.loading1 = false;
          Swal.fire({
            title: "¡Alerta!",
            text: "¡Debe seleccionar al menos dos designados empleador!",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        if (this.exist) {
          let response = await this.uploadDocument();
          if (response) {
            CopasstActAPI.updateAct(this.copasstAct.id, this.copasstAct)
              .then((resp) => {
                let promises = [];
                this.postulates.forEach((postulate) => {
                  if (postulate.employee_id) {
                    promises.push(
                      CandidatesCopasstAPI.updateCandidate(postulate.id, postulate)
                    );
                  }
                });

                this.employer.forEach((emp) => {
                  if (emp.employee_id) {
                    promises.push(
                      CandidatesCopasstAPI.updateCandidate(emp.id, emp)
                    );
                  }
                });

                Promise.all(promises)
                  .then((resp) => {
                    const itemChange = {
                      companies_id: this.companyID,
                      item_id: 6,
                      status: 'Pendiente',
                    };
                    newScoresAPI.calculateScores(itemChange)
                      .then((response) => {
                        this.loading1 = false;
                        setTimeout(() => {
                          Swal.fire({
                            title: "¡Éxito!",
                            text: "¡Se ha actualizado con éxito!",
                            icon: "success",
                            confirmButtonClass: "btn btn-confirm mt-2",
                          });
                        }, 3000);
                        this.goBack();
                      })
                      .catch((error) => {
                        this.loading1 = false;
                        setTimeout(() => {
                          Swal.fire({
                            title: "Error",
                            text: "¡No se ha podido registrar!",
                            icon: "error",
                            confirmButtonClass: "btn btn-confirm mt-2",
                          });
                          window.location.reload();
                        }, 3000);
                        console.log(error);
                      });
                  })
                  .catch((err) => {
                    Swal.fire({
                      title: "¡Error!",
                      text: "¡No sé pudo actualizar!",
                      icon: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                  });
              })
              .catch((error) => {
                Swal.fire({
                  title: "¡Error!",
                  text: "¡No sé pudo actualizar!",
                  icon: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
              });
          } else {
            this.loading1 = false;
            setTimeout(() => {
              Swal.fire({
                title: "¡Error!",
                text: "¡Error en la carga del acta!",
                icon: "error",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            }, 1500);
          }
        } else {
          CopasstActAPI.saveAct(this.copasstAct)
            .then((resp) => {
              const copasstID = resp.id;
              
              // Agregar la propiedad "type" a cada objeto
              const postulatesWithType = this.postulates
                .filter((postulate) => postulate.employee_id !== null)
                .map((postulate) => ({
                  ...postulate,
                  copasst_act_id: copasstID,
                  type: 'Postulado', // Agregar tipo Postulado
                }));

              const employerWithType = this.employer
                .filter((emp) => emp.employee_id !== null)
                .map((emp) => ({
                  ...emp,
                  copasst_act_id: copasstID,
                  type: 'Designado', // Agregar tipo Designado
                }));

              const data = [...postulatesWithType, ...employerWithType];

              CandidatesCopasstAPI.save(data)
                .then((resp) => {
                  const itemChange = {
                    companies_id: this.companyID,
                    item_id: 6,
                    status: 'Pendiente',
                  };
                  newScoresAPI.calculateScores(itemChange)
                    .then((response) => {
                      this.loading1 = false;
                      setTimeout(() => {
                        Swal.fire({
                          title: "¡Éxito!",
                          text: "¡Se ha registrado con éxito!",
                          icon: "success",
                          confirmButtonClass: "btn btn-confirm mt-2",
                        });
                        this.goBack();
                      }, 1000);
                    })
                    .catch((error) => {
                      this.loading1 = false;
                      setTimeout(() => {
                        Swal.fire({
                          title: "Error",
                          text: "¡No se ha podido registrar!",
                          icon: "error",
                          confirmButtonClass: "btn btn-confirm mt-2",
                        });
                        window.location.reload();
                      }, 1500);
                      console.log(error);
                    });
                })
                .catch((err) => {
                  this.loading1 = false;
                  Swal.fire({
                    title: "¡Error!",
                    text: "¡No se pudo registrar, error al guardar los asistentes!",
                    icon: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                });
            })
            .catch((err) => {
              this.loading1 = false;
              Swal.fire({
                title: "¡Error!",
                text: "¡No se pudo registrar, error al guardar el acta!",
                icon: "error",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            });
        }
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * This method is used to get the possible candidates.
     * This candidadtes are the employees with contract type 1 and status active.
     * Is require the company ID.
     */
    getCandidates() {
      CandidatesCopasstAPI.getAllPossibleCandidates(this.companyID)
        .then((response) => {
          this.candidates = response;
          this.candidatesSelect = response;
          this.employerCandidates = response;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    /**
     * This method is used to know the number of employees in the company.
     */
    getEmployees() {
      CompanyAPI.employeesCount(this.companyID)
        .then((response) => {
          this.employees = response.companies.employees_count || 0;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    download() {
      if (this.certificateExist) {
        window.location.href = this.copasstAct.certificate;
      }
    },

    /**
     * This method is used to know if the Copasst Act exists.
     * If exists, it will get the data.
     * If not, it will create a new Copasst Act.
     */
    getCopasst() {
      if (this.copasstID !== 0) {
        CopasstActAPI.getActById(this.copasstID)
          .then((response) => {
            const copasst = response[0] || null;
            this.exist = true;
            this.copastID = copasst.id

            if (copasst) {
              this.copasstAct = copasst;

              this.certificateExist = copasst.certificate ? true : false;

              this.postulates = copasst.copasst_candidates.filter(
                (candidate) => candidate.is_distinguished === 0
              );
              this.employer = copasst.copasst_candidates.filter(
                (candidate) => candidate.is_distinguished === 1
              );

              this.postulates.forEach((postulate) => {
                postulate.is_distinguished = false;
                if (postulate.president === 1) {
                  postulate.president = true;
                } else {
                  postulate.president = false;
                }

                if (postulate.secretary === 1) {
                  postulate.secretary = true;
                } else {
                  postulate.secretary = false;
                }
              });

              this.employer.forEach((emp) => {
                emp.is_distinguished = true;
                if (emp.president === 1) {
                  emp.president = true;
                } else {
                  emp.president = false;
                }

                if (emp.secretary === 1) {
                  emp.secretary = true;
                } else {
                  emp.secretary = false;
                }
              });
              this.loading1 = false;
            } else {
              this.exist = false;
              this.loading1 = false;
            }
          })
          .catch((error) => {
            console.log(error);
            this.loading1 = false;
          });
      } else {
        this.exist = false;
        this.loading1 = false;
      }
    },

    /**
     * This method is used to put the number of rows in the table postulates.
     */
    putPostulatesOnArray(number) {
      this.postulates = [];
      for (let i = 0; i < number; i++) {
        this.postulates.push({
          id: i,
          employee_id: null,
          copasst_status: null,
          copasst_votes: 0,
          is_distinguished: false,
          president: false,
          secretary: false,
          copasst_act_id: null,
        });
      }
    },

    /**
     * This method is used to put the number of rows in the table employers.
     */
    putEmployerOnArray(number) {
      this.employer = [];
      for (let i = 0; i < number; i++) {
        this.employer.push({
          id: i,
          employee_id: null,
          copasst_status: null,
          copasst_votes: 0,
          is_distinguished: true,
          president: false,
          secretary: false,
          copasst_act_id: null,
        });
      }
    },

    /**
     * This method validates if the assistants number is correct and then,
     * it will put the number of rows in the postulates table and table employers table.
     */
    getPostulatesNumber() {
      if (this.exist) {
        return;
      }

      if (
        this.copasstAct.number_assistants >= 10 &&
        this.employees >= this.copasstAct.number_assistants
      ) {
        this.putPostulatesOnArray(10);
        this.putEmployerOnArray(4);

        this.filterOptions();
        this.filterEmployerOptions();
      } else if (
        this.copasstAct.number_assistants >= 10 &&
        this.employees < this.copasstAct.number_assistants
      ) {
        this.putPostulatesOnArray(0);
        this.putEmployerOnArray(0);
        Swal.fire({
          title: "¡Alerta!",
          text: "¡El número de asistentes es mayor al número de empleados!",
          type: "warning",
          icon: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
      } else {
        this.putPostulatesOnArray(0);
        this.putEmployerOnArray(0);
        Swal.fire({
          title: "¡Error!",
          text: "¡El número de asistentes tiene que ser mayor o igual a diez!",
          type: "warning",
          icon: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
      }
    },

    getPositions() {
      let positions = [
        "REPRESENTANTE EMPLEADOS",
        "SUPLENTE REPRESENTANTE EMPLEADOS",
      ];
      this.positions = this.postulates.map((postulate) =>
        this.positions.filter(
          (position) => position != postulate.copasst_status
        )
      );
    },

    /**
     * This method is used to go back to the previous page.
     */
    goBack() {
      this.$router.go(-1);
    },

    filterOptions() {
      this.candidatesSelect = this.candidates.filter(
        (candidate) =>
          this.postulates.filter(
            (postulate) => postulate.employee_id === candidate.id
          ).length === 0
      );
    },

    filterEmployerOptions() {
      this.employerCandidates = this.candidates.filter(
        (candidate) =>
          this.employer.filter(
            (employer) => employer.employee_id === candidate.id
          ).length === 0
      );
    },

    getName(id) {
      if (id) {
        const cand = this.candidates.find((candidate) => candidate.id === id);
        if (cand) {
          return cand.full_name;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },

    onlyOnePresident(array, counterpart, id) {
      array.forEach((postulate) => {
        if (postulate.president) {
          postulate.president = false;
        }
      });
      counterpart.forEach((postulate) => {
        if (postulate.president) {
          postulate.president = false;
        }
      });
      array.find((postulate) => postulate.id === id).president = true;
    },

    onlyOneSecretary(array, counterpart, id) {
      array.forEach((postulate) => {
        if (postulate.secretary) {
          postulate.secretary = false;
        }
      });
      counterpart.forEach((postulate) => {
        if (postulate.secretary) {
          postulate.secretary = false;
        }
      });
      array.find((postulate) => postulate.id === id).secretary = true;
    },
  },
  mounted() {
    this.getCandidates();
    this.getEmployees();
    this.getCopasst();
    this.getItemData();
    this.getConformacionStatus();
  },
};
</script>

<template>
  <div class="row">
    <div class="col-lg-9">
      <div v-if="!loading1">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="save" class="form-group">
              <div class="form-row pt-3">
                <b-form-group class="col-md-6 px-2" label="Fecha" label-for="copasstDate">
                  <b-form-input :disabled="!allowAccess() ||
                    (!(getRole('Crear') && copasstID === 0) &&
                      !(getRole('Editar') && copasstID !== 0))
                    " type="date" id="copasstDate" v-model="copasstAct.announcement_date" :class="{
                      'is-invalid':
                        $v.copasstAct.announcement_date.$error && submitted,
                    }">
                    >
                  </b-form-input>
                  <div v-if="submitted && $v.copasstAct.announcement_date.$error">
                    <small v-if="!$v.copasstAct.announcement_date.required" class="text-danger">
                      <b>La fecha del acta de conformación Copasst es
                        requerida</b>
                    </small>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-6 px-2" label="Número de asistentes" label-for="assistantsNumber">
                  <ValidationProvider name="número de asistentes" :rules="`positive:${employees}`" v-slot="{ errors }">
                    <b-form-input :disabled="!allowAccess() ||
                      (!(getRole('Crear') && copasstID === 0) &&
                        !(getRole('Editar') && copasstID !== 0))
                      " class="form-control" type="number" v-model="copasstAct.number_assistants"
                      v-on:change="getPostulatesNumber" required :class="{ 'is-invalid': errors[0] }">
                    </b-form-input>
                    <div v-if="errors">
                      <small class="text-danger">
                        <b>{{ errors[0] }}</b>
                      </small>
                    </div>
                  </ValidationProvider>
                </b-form-group>
              </div>

              <div class="form-row pt-3">
                <b-form-group class="col-md-6 px-2" label="Hora inicio" label-for="startHour">
                  <b-form-input :disabled="!allowAccess() ||
                    (!(getRole('Crear') && copasstID === 0) &&
                      !(getRole('Editar') && copasstID !== 0))
                    " type="time" id="startHour" v-model="copasstAct.copasst_begin_hour" :class="{
                      'is-invalid':
                        $v.copasstAct.copasst_begin_hour.$error && submitted,
                    }">
                    >
                  </b-form-input>
                  <div v-if="submitted && $v.copasstAct.copasst_begin_hour.$error">
                    <small v-if="!$v.copasstAct.copasst_begin_hour.required" class="text-danger">
                      <b>La hora de inicio del acta de conformación Copasst es
                        requerida</b>
                    </small>
                  </div>
                </b-form-group>

                <b-form-group class="col-md-6 px-2" label="Hora cierre" label-for="endHour">
                  <b-form-input :disabled="!allowAccess() ||
                    (!(getRole('Crear') && copasstID === 0) &&
                      !(getRole('Editar') && copasstID !== 0))
                    " type="time" id="endHour" v-model="copasstAct.copasst_ending_hour" :class="{
                      'is-invalid':
                        $v.copasstAct.copasst_ending_hour.$error && submitted,
                    }">
                    >
                  </b-form-input>
                  <div v-if="submitted && $v.copasstAct.copasst_ending_hour.$error">
                    <small v-if="!$v.copasstAct.copasst_ending_hour.required" class="text-danger">
                      <b>La hora de cierre del acta de conformación Copasst es
                        requerida</b>
                    </small>
                  </div>
                </b-form-group>
              </div>

              <div class="form-row pt-3">
                <b-form-group class="col-md-12 px-2" label="Lugar" label-for="copasstPlace">
                  <b-form-textarea :disabled="!allowAccess() ||
                    (!(getRole('Crear') && copasstID === 0) &&
                      !(getRole('Editar') && copasstID !== 0))
                    " type="text" id="copasstPlace" v-model="copasstAct.copasst_place" :class="{
                      'is-invalid':
                        $v.copasstAct.copasst_place.$error && submitted,
                    }">
                    >
                  </b-form-textarea>
                  <div v-if="submitted && $v.copasstAct.copasst_place.$error">
                    <small v-if="!$v.copasstAct.copasst_place.required" class="text-danger">
                      <b>El lugar del acta de conformación Copasst es
                        requerido</b>
                    </small>
                  </div>
                </b-form-group>
              </div>

              <hr />

              <div class="row">
                <div class="col-lg-12">
                  <div class="card-body">
                    <h4>Postulados Empleados</h4>

                    <div class="table-responsive">
                      <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                        <thead>
                          <tr>
                            <th class="text-center">Nombre</th>
                            <th class="text-center">Numero de votos</th>
                            <th class="text-center">Cargo Copasst</th>
                            <th class="text-center">Presidente</th>
                            <th class="text-center">Secretario</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="postulate in postulates" :key="postulate.id">
                            <td class="text-left">
                              <div class="row">
                                <div class="col-md-9 col-sm-12 form-control input mx-1">
                                  {{ getName(postulate.employee_id) }}
                                </div>
                                <b-form-select :disabled="!allowAccess() ||
                                  (!(getRole('Crear') && copasstID === 0) &&
                                    !(getRole('Editar') && copasstID !== 0))
                                  " @change="filterOptions(postulate.employee_id)"
                                  class="form-control col-md-1 col-sm-12" v-model="postulate.employee_id">
                                  <option v-for="item in candidatesSelect" :value="item.id" :key="item.id">
                                    {{ item.full_name }}
                                  </option>
                                </b-form-select>
                              </div>
                            </td>
                            <td class="text-center">
                              <b-form-input type="number" class="form-control" v-model="postulate.copasst_votes"
                                :required="postulate.employee_id ? true : false">
                              </b-form-input>
                            </td>
                            <td class="text-center">
                              <select :disabled="!allowAccess() ||
                                (!(getRole('Crear') && copasstID === 0) &&
                                  !(getRole('Editar') && copasstID !== 0))
                                " class="form-control" v-model="postulate.copasst_status"
                                :required="postulate.employee_id ? true : false">
                                <option :value="0">N/A</option>
                                <option v-for="position in positions" :value="position.id" :key="position.id"
                                  v-on:change="getPositions">
                                  {{ position.name }}
                                </option>
                              </select>
                            </td>
                            <td class="text-center">
                              <b-form-checkbox v-model="postulate.president" name="check-button" switch @change="
                                postulate.president
                                  ? onlyOnePresident(
                                    postulates,
                                    employer,
                                    postulate.id
                                  )
                                  : null
                                ">
                              </b-form-checkbox>
                            </td>
                            <td class="text-center">
                              <b-form-checkbox v-model="postulate.secretary" name="check-button" switch @change="
                                postulate.secretary
                                  ? onlyOneSecretary(
                                    postulates,
                                    employer,
                                    postulate.id
                                  )
                                  : null">
                              </b-form-checkbox>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- end card -->
                </div>
                <!-- end col -->
              </div>

              <hr />

              <div class="row">
                <div class="col-md-12">
                  <div class="card-body">
                    <h4>Designados del Empleador</h4>
                    <div class="table-responsive">
                      <table class="mb-0 pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                        <thead>
                          <tr>
                            <th class="text-center">Nombre</th>
                            <th class="text-center">Cargo Copasst</th>
                            <th class="text-center">Presidente</th>
                            <th class="text-center">Secretario</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="emp in employer" :key="emp.id">
                            <td class="text-left">
                              <div class="row">
                                <div class="col-md-9 col-sm-12 form-control input mx-1">
                                  {{ getName(emp.employee_id) }}
                                </div>
                                <b-form-select @change="
                                  filterEmployerOptions(emp.employee_id)
                                  " class="form-control col-md-1 col-sm-12" v-model="emp.employee_id" :disabled="!allowAccess() ||
                                    (!(getRole('Crear') && copasstID === 0) &&
                                      !(getRole('Editar') && copasstID !== 0))
                                    ">
                                  <option v-for="item in employerCandidates" :value="item.id" :key="item.id">
                                    {{ item.full_name }}
                                  </option>
                                </b-form-select>
                              </div>
                            </td>
                            <td class="text-center">
                              <select :disabled="!allowAccess() ||
                                (!(getRole('Crear') && copasstID === 0) &&
                                  !(getRole('Editar') && copasstID !== 0))
                                " class="form-control" v-model="emp.copasst_status" :required="emp.employee_id">
                                <option :value="emp.id < 2 ? null : 0">
                                  N/A
                                </option>
                                <option v-for="position in positionsEmployer" :value="position.id" :key="position.id"
                                  v-on:change="getPositions">
                                  {{ position.name }}
                                </option>
                              </select>
                            </td>

                            <td class="text-center">
                              <b-form-checkbox v-model="emp.president" name="check-button" switch @change="
                                emp.president
                                  ? onlyOnePresident(
                                    employer,
                                    postulates,
                                    emp.id
                                  )
                                  : null
                                ">
                              </b-form-checkbox>
                            </td>
                            <td class="text-center">
                              <b-form-checkbox v-model="emp.secretary" name="check-button" switch @change="
                                emp.secretary
                                  ? onlyOneSecretary(
                                    employer,
                                    postulates,
                                    emp.id
                                  )
                                  : null
                                ">
                              </b-form-checkbox>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <div class="form-row">
                <b-form-group v-if="copasstID !== 0" class="col-lg-11 col-md-10 col-sm-12 px-2"
                  label="Acta de Conformación Copasst firmada" label-for="certificateCopasst">
                  <b-form-file :disabled="!allowAccess() ||
                    (!(getRole('Crear') && copasstID === 0) &&
                      !(getRole('Editar') && copasstID !== 0))" type="file" id="file" ref="file" name="file"
                    browse-text="Buscar"
                    :placeholder="copasstAct.certificate ? getFile(copasstAct.certificate) : `Selecciona un archivo...`"
                    drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                    accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                  </b-form-file>
                </b-form-group>
                <b-form-group v-if="copasstID !== 0" class="col-lg-1 col-sm-2 px-2" label="Descargar"
                  label-for="download">
                  <button :disabled="!allowAccess() ||
                    !getRole('Consultar') ||
                    !certificateExist
                    " type="button" :class="`btn ${certificateExist ? 'btn-outline-primary' : 'btn-secondary'
                      } btn-md`" @click="download()">
                    <i class="bx bx-download"></i>
                  </button>
                </b-form-group>
              </div>

              <hr />

              <div class="form-group text-right m-b-0">
                <button :disabled="guardando" type="submit" class="btn btn-primary">
                  Guardar
                </button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="text-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
      </div>
    </div>

    <div class="col-lg-3" v-if="copasstID !== 0">
      <h6 class="text-muted small mb-1">Acta de Conformación del COPASST</h6>
      <DocumentActions
        :document-id="Number(copasstID)"
        :company-id="companyID"
        :workflow-status="workflowStatus"
        :signed-at="signedAt"
        :api-service="conformacionApi"
        document-title="Acta de Conformación del COPASST"
        signer-role="gerente"
        @signed="onConfSigned"
      />
    </div>
  </div>
</template>